import { readable } from "svelte/store";
import { fetchResource } from "$misc/utils";

export default readable(fetchResource("countries"));
